import { User } from '@prisma/client'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { AppSessionType } from '~/features/appSession/common'
import { OnboardingValues } from '../../common'
import { StepConnection } from './components/StepConnection'
import { StepGoogleDrive } from './components/StepGoogleDrive'
import { StepOneDrive } from './components/StepOneDrive'

type Props = {
  user: User
  appSession: AppSessionType
  onSubmit: () => void
}

export const Onboarding: React.FC<Props> = ({ user, appSession, onSubmit }) => {
  const hasProviderAccount = (values: OnboardingValues) => {
    return (
      (values.fileServices?.provider === 'googleDrive' &&
        !!values.fileServices?.accountGoogleDrive) ||
      (values.fileServices?.provider === 'oneDrive' &&
        !!values.fileServices?.accountOneDrive)
    )
  }

  const valuesDefault: Partial<OnboardingValues> = {}

  const logic = CommonClient.Onboarding.useLogic({
    appSession,
    valuesDefault,
    onSubmit,
  })

  const isGoogle = logic.values?.fileServices?.provider !== 'oneDrive'

  return (
    <>
      <CommonClient.Onboarding.Wrapper<OnboardingValues>
        appSession={appSession}
        valuesDefault={valuesDefault}
        onSubmitted={onSubmit}
        steps={[
          {
            key: 'fileServices',
            content: props => (
              <StepConnection
                {...props}
                canNext={values => hasProviderAccount(values)}
              />
            ),
          },
          {
            key: 'googleDriveSettings',
            content: props => <StepGoogleDrive {...props} />,
            isVisible(values) {
              return values.fileServices?.provider === 'googleDrive'
            },
          },
          {
            key: 'oneDriveSettings',
            content: props => <StepOneDrive {...props} />,
            isVisible(values) {
              return values.fileServices?.provider === 'oneDrive'
            },
          },
        ]}
      />
    </>
  )
}
